export const CloseIcon = () => {
  return (
    <svg
      width="10"
      height="10"
      viewBox="0 0 10 10"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9.77314 1.28752L1.28786 9.7728C0.997947 10.0627 0.517115 10.0627 0.227201 9.7728C-0.0627129 9.48288 -0.0627128 9.00205 0.227201 8.71214L8.71248 0.226857C9.0024 -0.0630573 9.48323 -0.0630574 9.77314 0.226857C10.0631 0.516771 10.0631 0.997604 9.77314 1.28752Z"
        fill="#4A5368"
      />
      <path
        d="M9.77314 9.7728C9.48323 10.0627 9.0024 10.0627 8.71248 9.7728L0.227201 1.28752C-0.0627129 0.997603 -0.0627128 0.516771 0.227201 0.226857C0.517115 -0.063057 0.997947 -0.063057 1.28786 0.226857L9.77314 8.71214C10.0631 9.00205 10.0631 9.48288 9.77314 9.7728Z"
        fill="#4A5368"
      />
    </svg>
  );
};
